/**
 * The two marks a row's actions need that the shared set only has as
 * solid shapes: pause and play. A row's icons are all drawn the same
 * way (a 16 box, a 1.75 stroke, round ends), so one solid glyph among
 * thin ones reads as a mistake.
 */
type Props = { className?: string };

const base = {
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.75,
  strokeLinecap: "round" as const,
  strokeLinejoin: "round" as const,
};

export const IconPauseThin = ({ className }: Props) => (
  <svg {...base} className={className} aria-hidden="true">
    <path d="M6 3.5v9M10 3.5v9" />
  </svg>
);

export const IconPlayThin = ({ className }: Props) => (
  <svg {...base} className={className} aria-hidden="true">
    <path d="M5.5 3.6l7 4.4-7 4.4z" />
  </svg>
);
